import request from '@/utils/request'
import axios from 'axios'
import { getToken } from '@/utils/auth'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    withCredentials: true,
    timeout: 10000
  })

// 保存修改
export function addSave(data) {
  return request({
    url: '/salePeopleReport/save',
    method: 'post',
    data
  })
}
// 查询
export function getSalePeopleReport(id) {
  return request({
    url: `/salePeopleReport/get/${id}`,
    method: 'get'
  })
}
/**
 * 通过id删除
 */
 export function deleteSalePeopleReport(id) {
  return request({
    url: `/salePeopleReport/delete/${id}`,
    method: 'delete',
  })
}
export function exportFilePost(url, fileName, params) {
  service({
    method: 'post',
    url: url,
    data: params,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    responseType: 'blob'
  }).then(response => {
    const blob = new Blob([response.data], {
      type: 'application/vnd.ms-excel'
    })
    const downloadElement = document.createElement('a')
    const href = window.URL.createObjectURL(blob)
    downloadElement.href = href
    downloadElement.download = fileName
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement) // 下载完成移除元素
    window.URL.revokeObjectURL(href) // 释放掉blob对象
  }).catch(error => {
    console.log(error)
  })
}
export function exportFile(url, fileName, params) {
  service({
    method: 'get',
    url: url,
    params,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    responseType: 'blob'
  }).then(response => {
    const blob = new Blob([response.data], {
      type: 'application/vnd.ms-excel'
    })
    const downloadElement = document.createElement('a')
    const href = window.URL.createObjectURL(blob)
    downloadElement.href = href
    downloadElement.download = fileName
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement) // 下载完成移除元素
    window.URL.revokeObjectURL(href) // 释放掉blob对象
  }).catch(error => {
    console.log(error)
  })
}